module.exports = __webpack_public_path__ + "_/_/_/node_modules/@reverbdotcom/discovery-ui/images/homepage/join-l-82e1afc56a227940881e3460ca876835.svg";


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/images/homepage/join-l.svg
// module id = 996j
// module chunks = 9